import React from 'react'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom';

import CancelModal from '../../components/consultations/CancelConfirmModal'
import ConfirmModal from '../../components/consultations/new-flow/ConfirmModal';
import { payUpdatedAmountForAppointment } from '../../services';
import { alterRescheduleRequest, cancelNormalAppointment, reconfirmNormalAppointment } from './cardUtils'
import PayModal from './PayModal';

const CardModal = ({
    requestId,
    cardType,
    actionType,
    cancelCharge,
    onClose,
    onReload,
    authToken,
    modalText,
    pendingCopay
}) => {

    const history = useHistory()
    const decideCancelAction = () => {
        if (cardType.includes('appointment-reschedule')) {
            alterRescheduleRequest(requestId, authToken, onReload, onClose, 'cancel')
        } else {
            cancelNormalAppointment(requestId, cancelCharge, authToken, onReload, onClose)
        }
    }

    const decideConfirmAction = () => {
        if (cardType.includes('appointment-reschedule')) {
            if (!pendingCopay) {
                alterRescheduleRequest(requestId, authToken, onReload, onClose, 'confirm')
            } else {
                payUpdatedAmountForAppointment(requestId, pendingCopay, authToken, history)
            }
        } else {
            reconfirmNormalAppointment(requestId, authToken, onReload, onClose)
        }
    }

    if (!cardType || !actionType) return <></>

    if (actionType === 'cancel') {
        return <CancelModal
            hideModal={onClose}
            message={'Are you sure you want to cancel this appointment?'}
            submit={decideCancelAction}
        />
    } else if (actionType === 'confirm') {
        if (cardType.includes('appointment-reschedule') && pendingCopay) {
            return <PayModal
                onSubmit={decideConfirmAction}
                pendingCopay={pendingCopay}
                onClose={onClose}
            />
        } else {
            return <ConfirmModal
                hideModal={onClose}
                reschedule={cardType.includes('appointment-reschedule')}
                reconfirmRequest={decideConfirmAction}
                openSlotSelection={decideConfirmAction}
                confirmText={modalText || false}
            />
        }
    }

    return <></>
}

const matchStateToProps = (state) => ({
    authToken: state.user.authToken
})

export default connect(matchStateToProps)(CardModal)